import React, { createContext, useContext, useEffect, useState } from "react";
import { login as apiLogin, logout as apiLogout, getStoredUser, VcgUser } from "../services/auth";

type AuthCtx = {
  isAuthenticated: boolean;
  user: VcgUser | null;
  login: (email: string, password: string, rememberMe: boolean) => Promise<{ success: boolean; message?: string }>;
  logout: () => void;
};

const Ctx = createContext<AuthCtx>(null!);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<VcgUser | null>(getStoredUser());
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(!!user);

  useEffect(() => {
    // bootstrap from localStorage (already done above); keep both in sync if needed
    setIsAuthenticated(!!user);
  }, [user]);

  const login = async (email: string, password: string, rememberMe: boolean) => {
    try {
      console.log('🔄 AuthContext: Starting login process...');
      console.log('📧 Email:', email);
      console.log('🔒 Password length:', password.length);
      console.log('💾 Remember me:', rememberMe);
      
      console.log('📡 About to call apiLogin...');
      const res = await apiLogin(email, password, rememberMe);
      
      console.log('✅ AuthContext: Login successful!', res);
      setUser(res.user);
      setIsAuthenticated(true);
      return { success: true };
    } catch (e: any) {
      console.error('❌ AuthContext: Login failed with error:', e);
      console.error('🔍 Error details:', {
        message: e?.message,
        response: e?.response,
        responseData: e?.response?.data,
        responseStatus: e?.response?.status,
        stack: e?.stack
      });
      
      const msg = e?.response?.data?.error?.message || "Invalid email or password. Please try again.";
      console.log('📝 Error message to show:', msg);
      return { success: false, message: msg };
    }
  };

  const logout = () => {
    console.log('🚪 AuthContext: Logging out...');
    apiLogout();
    setUser(null);
    setIsAuthenticated(false);
  };

  return (
    <Ctx.Provider value={{ isAuthenticated, user, login, logout }}>
      {children}
    </Ctx.Provider>
  );
};

export const useAuth = () => useContext(Ctx);